import { FormField } from '@amzn/awsui-components-core';
import React, { useEffect, useState } from 'react';
import { TiptapOutputType, getText } from '@amzn/awscat-editor';
import constants from '../../common/constants';
import EditorWrapper from '../../editor/EditorWrapper';
import { TiptapMenuType } from '../../editor/utils';

export interface ContentPageTitleInputProps {
  title: TiptapOutputType;
  showValidationError?: boolean;
  onUpdated: (title: TiptapOutputType, error?: string) => void;
}

export const ContentPageTitleInput = (props: ContentPageTitleInputProps) => {
  const validateTitle = (newTitle: TiptapOutputType) => {
    const titleText = getText(newTitle);
    const error =
      !titleText || titleText.length < 1 || titleText.length >= 60
        ? constants.ADD_NEW_PAGE_TITLE_LENGTH_VALIDATION_ERROR
        : undefined;

    return error;
  };

  const [title, setTitle] = useState<TiptapOutputType>(props.title);
  const [validationError, setValidationError] = useState<string>();

  useEffect(() => {
    setTitle(props.title);
  }, [props.title]);

  const updateTitle = (content: TiptapOutputType) => {
    const error = validateTitle(content);

    setTitle(content);
    setValidationError(error);

    if (props.onUpdated) {
      props.onUpdated(content, error);
    }
  };

  return (
    <FormField
      errorText={props.showValidationError ? validationError : null}
      label={constants.ADD_NEW_PAGE_TITLE_LABEL}
      stretch
      i18nStrings={{ errorIconAriaLabel: 'Error' }}
    >
      <EditorWrapper
        model={title}
        onModelChange={updateTitle}
        menuType={TiptapMenuType.Hide}
        autoFocus={true}
      />
    </FormField>
  );
};
